<template>
  <section class="step2">
    <div class="quiz_content_area pt-80 pb-80">
      <div class="row justify-content-center">
        <div class="col-sm-3">
          <div class="quiz_card_area">
            <input
              v-model="message.model"
              class="quiz_checkbox"
              type="radio"
              value="model"
              @input="changeMessageModel"
            />
            <div class="single_quiz_card">
              <div class="quiz_card_content">
                <div class="quiz_card_icon">
                  <div class="quiz_icon quiz_icon3"></div>
                </div>
                <div class="quiz_card_title">
                  <h3>
                    <i v-if="message.model === 'model'" class="fa fa-check" aria-hidden="true"></i>
                    {{ __('message_interface.step2.choose_model') }}
                  </h3>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-3">
          <div class="quiz_card_area">
            <input
              v-model="message.model"
              class="quiz_checkbox"
              type="radio"
              value="write"
              @input="changeMessageModel"
            />
            <div class="single_quiz_card">
              <div class="quiz_card_content">
                <div class="quiz_card_icon">
                  <div class="quiz_icon quiz_icon4"></div>
                </div>
                <div class="quiz_card_title">
                  <h3>
                    <i v-if="message.model === 'write'" class="fa fa-check" aria-hidden="true"></i>
                    {{ __('message_interface.step2.write_msg') }}
                  </h3>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-12" v-if="message.model === 'model'">
          <div class="col-sm-6 offset-3">
            <div class="form-group">
              <label>
                {{ __('message_interface.step2.choose_model') }}
              </label>
              <Multiselect
                v-model="message.selectedMessageModel"
                :options="templateOptions"
                :multiple="false"
                :placeholder="__('message_interface.step2.type_search')"
                group-values="messages"
                group-label="language"
                track-by="name"
                label="name"
                @select="selectMessageModel"
              >
                <span slot="noResult">
                  {{ __('message_interface.step2.no_element') }}
                </span>
              </Multiselect>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-12">
      <button class="btn btn-primary" @click="$emit('prev-tab')">
        {{ __('message_interface.btns.prev') }}
      </button>
      <button
        class="btn btn-primary float-right"
        @click="$emit('next-tab')"
        :disabled="message.messageToSend === null"
      >
        {{ __('message_interface.btns.next') }}
      </button>
    </div>
    <div class="clearfix"></div>
  </section>
</template>

<script>
import Multiselect from 'vue-multiselect'
import { usePage } from '@inertiajs/vue3'

const page = usePage()

export default {
  name: 'MessageModel',
  props: ['message', 'smsTemplates', 'emailTemplates'],
  components: {
    Multiselect
  },
  data() {
    return {
      smsModels: [],
      emailModels: [],
      value: [],
      selectedMessage: false,
      showSelectMessage: false,
      lang: {
        en: {
          en: 'English',
          fr: 'Anglais'
        },
        fr: {
          en: 'French',
          fr: 'Français'
        }
      }
    }
  },
  created() {
    let langEn = page.props.locale === 'en' ? this.lang.en.en : this.lang.en.fr
    let langfr = page.props.locale === 'fr' ? this.lang.fr.fr : this.lang.fr.en
    this.smsModels.push({
      language: langEn,
      messages: this.smsTemplates.en ?? []
    })
    this.smsModels.push({
      language: langfr,
      messages: this.smsTemplates.fr ?? []
    })
    this.emailModels.push({
      language: langEn,
      messages: this.emailTemplates.en ?? []
    })
    this.emailModels.push({
      language: langfr,
      messages: this.emailTemplates.fr ?? []
    })
  },
  computed: {
    templateOptions() {
      return this.message.type === 'sms' ? this.smsModels : this.emailModels
    }
  },
  methods: {
    changeMessageModel(message) {
      if (message.target.value === 'model') {
        this.showSelectMessage = true
        this.message.messageToSend === '' ? (this.message.messageToSend = null) : ''
      } else {
        this.showSelectMessage = false
        this.selectedMessage = false
        this.message.messageToSend = ''
        this.message.selectedMessageModel = {
          id: null,
          name: null,
          content: null,
          subject: null
        }
      }
    },
    selectMessageModel(message) {
      if (message !== null) {
        this.$emit('selectMessageModel', message)
      }
    }
  }
}
</script>
